<template>
  <RouterView />
  <AdminToastRegion />
  <AdminConfirmationDialog />
</template>

<script setup lang="ts">
import AdminConfirmationDialog from "./components/AdminConfirmationDialog.vue";
import AdminToastRegion from "./components/AdminToastRegion.vue";
</script>
